<template>
  <v-app cloak>
    <v-navigation-drawer
    permanent
    app
    v-if="!$route.meta.hideNavigation"
    :mini-variant.sync="mini"
    >
      <v-list-item>
        <v-btn
          icon
          @click.stop="mini = !mini"
        >
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
      </v-list-item>

      <v-divider></v-divider>

      <v-list
          dense
          nav
        >
          <v-list-item
            v-for="item in menu_items"
            :key="item.title"
            :to="item.link"
          >
            <v-list-item-icon>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
    </v-navigation-drawer>
  <v-app-bar
    app
    dense
    v-if="!$route.meta.hideNavigation">
    <div class="flex-grow-1"></div>
    <!--<v-btn icon>
      <v-icon>mdi-magnify</v-icon>
    </v-btn>-->
    <v-btn icon>
      <v-icon @click="logout_from_app">mdi-export-variant</v-icon>
    </v-btn>
  </v-app-bar>

  <!-- Sizes your content based upon application components -->
  <v-content>

    <!-- Provides the application the proper gutter -->
    <v-container fluid>

      <!-- If using vue-router -->
      <router-view
        :api_prefix="api_prefix"
        :user="user"
        :account="account"
        :subscription_plan="subscription_plan"
        :setup_completed="setup_completed"
        @navigation_drawer="toggle_navigation_drawer"
        @refresh_auth_token="parse_auth_token"
      >
      </router-view>
      <!--<div v-else>
        <v-progress-circular
        id="loading_spinner"
        indeterminate
        size=64
        color="primary"
        >
        </v-progress-circular>
      </div>-->
    </v-container>
  </v-content>

  <v-footer app>
    <!-- -->
  </v-footer>
</v-app>
</template>

<script>
var WebFont = require('webfontloader');
import router from './router.js';

//could also do:
//npm install --save material-design-icons-iconfont
//and import it in the main.js file
//import 'material-design-icons-iconfont/dist/material-design-icons.css'
WebFont.load({
  google: {
    families: ['Roboto', 'Material+Icons']
  }
})

export default {
  name: 'app',
  metaInfo: {
      // if no subcomponents specify a metaInfo.title, this title will be used
      title: 'Cub Cash',
  },
  data: function () {
    return {
      user: null,
      account: null,
      organization_id: null,
      setup_completed: null,
      nav_drawer: null,
      mini: false,
      api_prefix: process.env.VUE_APP_API_PREFIX,
      subscription_plan: null,
      token_claims_loop: null,
      is_mobile: false,
      counter: 0,
      force_refresh: false,
      menu_items:
      [
        {
          'title': 'Dashboard', 'icon': 'mdi-database', 'link': '/dashboard'
        },
        {
          'title': 'Settings', 'icon': 'settings', 'link': '/settings'
        },
        {
          'title': 'Help', 'icon': 'help', 'link': '/help'
        }
      ],
    }
  },
  created()
  {
    let self = this;

    console.log('in app api prefix is:' + self.api_prefix);
    console.log(process.env.VUE_APP_FIREBASE_API_KEY);
  },
  components: {
    //'navigation-sidebar': NavigationSidebar,
  },
  methods: {
    toggle_navigation_drawer(hide)
    {
      this.show_sidebar = false;
    },
    async get_setup_completed()
    {
        try
        {
          var response = await this.$http.get(self.api_prefix + '/setup_completed',
          {});
          self.setup_completed = response.data;
          //set the localstorage to the setup_completed value
          localstorage.setItem('setup_completed', self.setup_completed);
        }
        catch (error)
        {
        }
    },
    set_nav_bar_size()
    {
      if (('ontouchstart' in document.documentElement && navigator.userAgent.match(/Mobi/))==false)
      {
        this.mini = false;
      }
      else
      {
        this.mini = true;
      }
    },
    logout_from_app()
    {
      //router.push("login")
    },
    async get_account()
    {
      let self = this
      var response = await self.$http.get(self.api_prefix + '/account',
      {
      },
      );
      console.log(response);
      if(response.data!=null && response.data.status==true)
      {
        self.account = response.data
      }
    },
    get_auth_token()
    {
      var url = location.search;
      var query = url.substr(1);
      var result = {};
      query.split("&").forEach(function(part) {
        var item = part.split("=");
        result[item[0]] = decodeURIComponent(item[1]);
      });
      if (result.auth_token!=null)
      {
        localStorage.setItem('auth_token', result.auth_token)
        return result.auth_token
      }
      else
      {
        console.log('auth_token missing - trying localstorage')
        var stored_auth_token = localStorage.getItem('auth_token')
        if (stored_auth_token!=null)
        {
          return stored_auth_token
        }
        else
        {
          console.log('auth_token missing')
          return null;
        }
      }
    },
    parse_auth_token()
    {
      let self = this;
      self.auth_token = self.get_auth_token()

      if (self.auth_token!=null)
      {
        //leverage Axios interceptors to append the token to every request
        self.$http.interceptors.request.use(async config => {
          //https://github.com/axios/axios#request-config
          //self.token = localStorage.getItem('token')
          const credentials = btoa("cub_cash_user" + ":" + self.auth_token);
          config.headers.Authorization = 'Basic ' + credentials
          return config
        }, (error) => {
          return Promise.reject(error)
        })

        self.get_account()
      }
    },
  },
  mounted: function()
  {
    this.set_nav_bar_size()
    this.parse_auth_token()
  },
  computed: 
  {
  },
  watch: 
  {
    '$route' (to, from) 
    {
      let self = this;
      document.title = to.meta.title || 'Cub Cash'
      setTimeout(self.set_nav_bar_size, 1500);
    },
  },

}
</script>

<style scoped>
[v-cloak] {display: none}
a:hover
{
  text-decoration: none;
}
.container, .container--fluid
{
	height: 100%;
}
</style>
